import { render, staticRenderFns } from "./BankAdd.vue?vue&type=template&id=60235b10&scoped=true"
import script from "./BankAdd.vue?vue&type=script&lang=js"
export * from "./BankAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60235b10",
  null
  
)

export default component.exports